var render, staticRenderFns
import script from "./redEnvelope.vue?vue&type=script&lang=js"
export * from "./redEnvelope.vue?vue&type=script&lang=js"
import style0 from "./redEnvelope.vue?vue&type=style&index=0&id=4b0e9bfe&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports